<script setup lang="ts">
defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
})

const { isTrueDesktop } = useBSBreakpoints()
</script>

<template>
  <div
    :class="[
      'hamburger',
      { 'is-open': isOpen, 'hidden': isTrueDesktop }
    ]"
  >
    <span />
    <span />
  </div>
</template>

<style lang="scss" scoped>
.hamburger {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 2.4rem;
  padding: 0.7rem 0;

  span {
    display: inline-block;
    width: 3.2rem;
    height: 0.2rem;
    background-color: $text-400;
    transition: 0.1s all ease;
  }

  &.is-open {
    span:nth-child(1) {
      transform: rotate(45deg) translateY(3px) translateX(3px);
    }

    span:nth-child(2) {
      transform: rotate(-45deg) translateY(-3px) translateX(3px);
    }
  }

  &.hidden {
    display: none;
  }
}
</style>
